import image from '../assets/image.jpg';
import image3 from '../assets/image3.png';
import image4 from '../assets/image4.jpg';
import image6 from '../assets/image6.png';
import image7 from '../assets/image7.png';
import image8 from '../assets/image8.png';
import image9 from '../assets/image9.png';

export const projectData = [
  {
    id: 1,
    image: image9,
    title: 'Solar Kiosk',
    date: 'August 2025',
    description: 'I developed the software and hardware for a solar monitoring kiosk, then deployed it at the SPCA.',
    link: 'https://github.com/jacobarychuk/kiosk',
    tags: [
      { label: 'JavaScript', color: 'hsl(50, 100%, 40%)' },
      { label: 'Flask', color: 'hsl(0, 100%, 40%)' },
      { label: 'Python', color: 'hsl(75, 100%, 40%)' },
      { label: 'SQLite', color: 'hsl(240, 100%, 40%)' },
      { label: 'PlatformIO', color: 'hsl(34, 100%, 40%)' },
      { label: 'C++', color: 'hsl(240, 100%, 20%)' },
    ],
  },
  {
    id: 2,
    image: image8,
    title: 'Traffic Light System',
    date: 'March 2025',
    description: 'I designed a real-time embedded system to simulate traffic on a one-way road. I implemented it using FreeRTOS and built a circuit using the STM32F4DISCOVERY development board.',
    link: 'https://github.com/jacobarychuk/Traffic-Light-System',
    tags: [
      { label: 'C', color: 'hsl(240, 100%, 20%)' },
      { label: 'FreeRTOS', color: 'hsl(130, 100%, 20%)' },
    ],
  },
  {
    id: 3,
    image: image4,
    title: 'PWM Control System',
    date: 'September 2024',
    description: 'I built and programmed a PWM control system using an STM32F051R8T6 microcontroller.',
    link: 'https://github.com/jacobarychuk/PWM-Control-System',
    tags: [
      { label: 'C', color: 'hsl(240, 100%, 20%)' },
    ],
  },
  {
    id: 4,
    image: image3,
    title: 'Radio Keyword Recorder',
    date: 'January 2026',
    description: 'I wrote a script to automate the capture of radio contest keywords for sweepstakes entry without having to manually listen.',
    link: 'https://github.com/jacobarychuk/Radio-Keyword-Recorder',
    tags: [
      { label: 'Python', color: 'hsl(75, 100%, 40%)' },
    ],
  },
  {
    id: 5,
    image: image,
    title: 'Responsive Masonry Layout',
    date: 'January 2025',
    description: "I published my first public software package! It's a component for React.",
    link: 'https://www.npmjs.com/package/responsive-masonry-layout',
    tags: [
      { label: 'React', color: 'hsl(200, 100%, 40%)' },
      { label: 'JavaScript', color: 'hsl(50, 100%, 40%)' },
    ],
  },
];
